import { cn } from "@/domains/library"

export const PageContainer = ({ children }: { children: React.ReactNode }) => {
  const showBorders = false
  return (
    <div
      className={cn(
        "page-container mx-auto ",
        "flex-grow",
        "w-full min-w-[320px] max-w-[calc(2200px-128px)]",
        showBorders && "border border-pink-800",
        "mb-8 px-2 py-4",
        "sm:px-2 sm:py-8",
        "md:px-4 md:py-8",
        "lg:px-4 lg:py-8",
        "xl:px-4 xl:py-16 2xl:px-4",
      )}
    >
      <div className={cn("page-container-content", "w-full", showBorders && "border border-pink-100")}>{children}</div>
    </div>
  )
}
